<template>
  <div
    :class="{ 'visible': isOpen }"
    class="modal-wrapper"
  >
    <div class="modal">
      <div class="modal-header">
        <h2 class="is-size-5">
          <b v-if="type === 'create'">New Event</b>
          <b v-else>Edit Event</b>
        </h2>
      </div>
      <div class="modal-body">
        <div class="columns">
          <div class="column is-full">
            <TextField
              :label="'Name'"
              :placeholder="'My New Event'"
              :name="'eventname'"
              :initial-value="name"
              :message="nameMessage"
              :extraClass="nameMessage ? nameMessage.class : ''"
              @changedValue="saveName"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column is-full">
            <TextField
              :label="'Description'"
              :placeholder="'Describe this event'"
              :initial-value="description"
              :name="'description'"
              @changedValue="saveDescription"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <DateField
              :label="'Start Date'"
              :placeholder="'Select date'"
              :message="startDateMessage"
              :initial-value="startDate"
              :extraClass="startDateMessage ? startDateMessage.class : ''"
              :disabled-dates="disabledStartDates"
              @changedValue="saveStartDate"
            />
          </div>
          <div class="column">
            <DateField
              :label="'End Date'"
              :placeholder="'End date'"
              :message="endDateMessage"
              :initial-value="endDate"
              :extraClass="endDateMessage ? endDateMessage.class : ''"
              :disabled-dates="disabledEndDates"
              @changedValue="saveEndDate"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <Checkbox
              :label="'Includes registration period'"
              :initial-value="registrationPeriod"
              @changedValue="saveRegistrationPeriod"
            />
          </div>
        </div>
        <div
          v-if="registrationPeriod"
          class="columns"
        >
          <div class="column">
            <DateField
              :label="'Registration Start Date'"
              :placeholder="'Select date'"
              :message="registrationStartDateMessage"
              :initial-value="registrationStartDate"
              :extraClass="registrationStartDateMessage ? registrationStartDateMessage.class : ''"
              :disabled-dates="disabledRegistrationStartDates"
              @changedValue="saveRegistrationStartDate"
            />
          </div>
          <div class="column">
            <DateField
              :label="'Registration End Date'"
              :placeholder="'End date'"
              :message="registrationEndDateMessage"
              :initial-value="registrationEndDate"
              :extraClass="registrationEndDateMessage ? registrationEndDateMessage.class : ''"
              :disabled-dates="disabledRegistrationEndDates"
              @changedValue="saveRegistrationEndDate"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a
          href="#"
          class="button is-light"
          @click.prevent="closeModal(false)"
        >Cancel</a>
        <a
          href="#"
          :class="{ 'is-loading': submitting }"
          class="button is-warning has-text-weight-bold"
          :disabled="!isValid || submitting"
          @click.prevent="submitForm"
        >
          <span v-if="type === 'create'">Save</span>
          <span v-else>Update</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/inputs/TextField'
import DateField from '@/components/inputs/DateField'
import Checkbox from '@/components/inputs/Checkbox'

import inputMessages from '@/configs/inputMessages'
import moment from 'moment'

export default {
  name: 'EventModal',
  components: {
    TextField,
    DateField,
    Checkbox
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'create'
    },
    initialData: {
      type: [Object, Boolean],
      default: false
    }
  },
  data () {
    return {
      //  Values
      _id: '',
      name: '',
      description: '',
      startDate: '',
      endDate: '',
      registrationPeriod: false,
      registrationStartDate: '',
      registrationEndDate: '',
      disabledStartDates: {
        to: moment().startOf('day').toDate()
      },
      disabledEndDates: {
        to: moment().startOf('day').toDate()
      },
      disabledRegistrationStartDates: {
        to: moment().startOf('day').toDate()
      },
      disabledRegistrationEndDates: {
        to: moment().startOf('day').toDate()
      },
      //  Errors
      nameMessage: false,
      startDateMessage: false,
      endDateMessage: false,
      registrationStartDateMessage: false,
      registrationEndDateMessage: false,
      //  State
      submitting: false

    }
  },
  mounted () {
    if (this.initialData) {
      this.populateFields()
      setTimeout(() => {
        this.validateFields()
      }, 250)
    }
  },
  computed: {
    isValid () {
      return this.validateFields()
    }
  },
  methods: {
    saveName (value) {
      if (value.trim().length > 0) {
        this.name = value.trim()
        this.nameMessage = false
      } else {
        this.nameMessage = inputMessages.required
        this.name = value
      }
    },
    saveDescription (value) {
      if (value.trim().length > 0) {
        this.description = value.trim()
      }
    },
    saveStartDate (value) {
      if (value) {
        if (typeof this.endDate === 'object') {
          if (moment(value).isAfter(moment(this.endDate))) {
            alert('error')
            return
          }
        }

        this.startDateMessage = false
        this.startDate = moment(value).startOf('day').toDate()
        this.disabledEndDates = {
          to: moment(this.startDate).startOf('day').toDate()
        }

        this.disabledRegistrationStartDates = {
          to: moment().subtract(1, 'day').startOf('day').toDate(),
          from: moment(this.startDate).endOf('day').toDate()
        }
        this.disabledRegistrationEndDates = {
          to: moment().subtract(1, 'day').startOf('day').toDate(),
          from: moment(this.startDate).endOf('day').toDate()
        }

      } else {
        this.startDateMessage = inputMessages.required
      }
    },
    saveEndDate (value) {
      if (value) {
        if (typeof this.startDate === 'object') {
          if (moment(value).isBefore(moment(this.startDate))) {
            alert('error')
            return
          }
        }
        this.endDateMessage = false
        this.endDate = moment(value).endOf('day').toDate()
        this.disabledStartDates = {
          to: moment().subtract(1, 'day').startOf('day').toDate(),
          from: this.endDate
        }
      } else {
        this.endDateMessage = inputMessages.required
      }
    },
    saveRegistrationPeriod (value) {
      this.registrationPeriod = value
    },
    saveRegistrationStartDate (value) {
      if (value) {
        this.registrationStartDateMessage = false
        this.registrationStartDate = moment(value).startOf('day').toDate()
      } else {
        this.registrationStartDateMessage = inputMessages.required
      }
    },
    saveRegistrationEndDate (value) {
      if (value) {
        this.registrationEndDateMessage = false
        this.registrationEndDate = moment(value).endOf('day').toDate()
      } else {
        this.registrationEndDateMessage = inputMessages.required
      }
    },
    validateFields () {
      let valid = false
      if (
        this.name.length > 0 &&
        typeof this.startDate === 'object' &&
        typeof this.endDate === 'object'
      ) {
        if (this.registrationPeriod) {
          if (
            typeof this.registrationStartDate === 'object' &&
            typeof this.registrationEndDate === 'object'
          ) {
            valid = true
          }
        } else {
          valid = true
        }
      }
      return valid
    },
    submitForm () {
      if (this.isValid) {
        this.submitting = true

        let data = {}
        let apiCall = ''

        if (this.type === 'create') {
          data['name'] = this.name
          data['startDate'] = this.startDate
          data['endDate'] = this.endDate

          if (this.description.length > 0) {
            data['description'] = this.description
          }

          if (this.registrationPeriod) {
            data['registrationPeriod'] = true
            data['registrationStartDate'] = this.registrationStartDate
            data['registrationEndDate'] = this.registrationEndDate
          }

          apiCall = 'admin/SAVE_EVENT'
        } else {

          let unset = {}

          data = {
            'match': {
              _id: this._id
            },
            'update': {
              '$set': {
                name: this.name,
                eventStartDate: this.startDate,
                eventEndDate: this.endDate,
                registrationPeriod: this.registrationPeriod
              }
            }
          }

          if (this.description) {
            data.update['$set']['description'] = this.description
          } else {
            unset['description'] = ''
          }

          if (this.registrationPeriod) {
            data.update['$set']['registrationStartDate'] = this.registrationStartDate
            data.update['$set']['registrationEndDate'] = this.registrationEndDate
          } else {
            unset['registrationStartDate'] = ''
            unset['registrationEndDate'] = ''
          }

          if (Object.keys(unset).length > 0) {
            data['update']['$unset'] = unset
          }

          apiCall = 'admin/UPDATE_EVENT'
        }

        console.log(data)

        this.$store
          .dispatch(apiCall, data)
          .then(res => {
            this.submitting = false
            this.closeModal(true)
            let message = this.type === 'create' ? 'Added new event' : 'Updated event'
            this.$toasted.success(message)
          })
          .catch(err => {
            this.submitting = false
            this.$toasted.error('Error saving new event')
            console.log(err)
          })
      }
    },
    closeModal (refresh) {
      this.$emit('closeModal', refresh)
    },
    populateFields () {
      this._id = this.initialData._id
      this.name = this.initialData.name
      this.description = this.initialData.description
      this.startDate = new Date(this.initialData.startDate)
      this.endDate = new Date(this.initialData.endDate)
      this.registrationPeriod = this.initialData.registrationPeriod
      this.registrationStartDate = this.initialData.registrationPeriod ? new Date(this.initialData.registrationStartDate) : ''
      this.registrationEndDate = this.initialData.registrationPeriod ? new Date(this.initialData.registrationEndDate) : ''
    }

  }
}
</script>
